import React, { useCallback } from 'react';
import { Modal, ModalHeader, ModalBody, Col, Row } from 'reactstrap';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import FormInputField from '../../../common/components/formFields/FormInputField';
import CommonButton from '../../../common/components/CommonButton';
import { CommonButtonVariants } from '../../../constants/CommonButtonVariants';
import SettingsSectionHeader from '../../SettingsSectionHeader';
import PostcodeSelectField from '../../../register/forms/postcode/PostcodeSelectField';
import validationSchema from './AddAddress.schema';
import '../../../assets/css/componentStyles/AddAddressModal.css';

const initialValues = {
  location: '',
  postalCode: '',
  city: '',
  address: '',
  address2: '',
  county: '',
};

function AddAddressModal({ isOpen, toggle, onSave }) {
  const handleSubmit = useCallback(
    (values, { resetForm }) => {
      onSave(values);
      resetForm();
      toggle();
    },
    [onSave, toggle],
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      backdropClassName="add-address-modal-backdrop"
      className="add-address-modal"
    >
      <ModalHeader toggle={toggle} tag="div">
        <SettingsSectionHeader
          header="Add Another Address"
          variant="noBorder"
          headerClassName="add-address-modal-header"
        />
      </ModalHeader>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form>
            <ModalBody>
              <Row className="">
                <Col md={12}>
                  <FormInputField
                    name="location"
                    label="Location Name"
                    labelVariant="bordered"
                    required
                  />
                </Col>
                <Col md={12} className="mt-3">
                  <FormInputField
                    name="address"
                    label="Address"
                    labelVariant="bordered"
                    required
                  />
                </Col>
                <Col md={6} className="mt-3">
                  <FormInputField
                    name="address2"
                    label="Address - Line 2"
                    labelVariant="bordered"
                  />
                </Col>
                <Col md={6} className="mt-3">
                  <FormInputField name="city" label="Town" labelVariant="bordered" required />
                </Col>
                <Col md={6} className="mt-3">
                  <FormInputField
                    name="county"
                    label="County"
                    labelVariant="bordered"
                    required
                  />
                </Col>
                <Col md={6} className="mt-3">
                  <PostcodeSelectField
                    name="postalCode"
                    label="Post Code"
                    labelVariant="bordered"
                    required
                  />
                </Col>
              </Row>
            </ModalBody>
            <Row className="mb-3 add-address-modal-buttons">
              <Col xs={6}>
                <CommonButton
                  label="Save"
                  variant={CommonButtonVariants.PRIMARY_RED}
                  type="submit"
                  disabled={isSubmitting || !isValid || !dirty}
                  className="w-100"
                />
              </Col>
              <Col xs={6}>
                <CommonButton
                  label="Cancel"
                  variant={CommonButtonVariants.OUTLINED_RED}
                  handleClick={toggle}
                  className="w-100 "
                  type="button"
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

AddAddressModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default AddAddressModal;
